<div
  class="tag {{ classList }} uppercase"
  [ngClass]="{ selected: isSelected, 'add-custom-tag': isAddCustomTag }"
  [attr.data-category]="tagCategory"
  [style.border-color]="!isAddCustomTag && tag ? accentVar() : null"
  [style.background]="!isAddCustomTag && !isAddCustomClass && tag ? (isSelected ? gradientVar() : tintVar()) : null"
>
  <svg-icon
    *ngIf="isAddCustomTag"
    src="assets/icons/icon-zoom-in.svg"
    [svgStyle]="{
      'width.rem': 0.46875,
      'height.rem': 0.46875,
    }"
  ></svg-icon>
  <span class="font-secondary font-bold">{{
    isAddCustomTag ? "Add custom tag" : tag.name
  }}</span>
</div>
